import { Box, Typography } from "@mui/material";
import GradientIcon from "../../components/GradientIcon";

import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";

const items = [
  {
    title: "Reduce Content Chaos",
    desc: "Centralize and organize assets for easy access.",
    icon: FilterAltOutlinedIcon,
  },
  {
    title: "Improve Team Collaboration",
    desc: "Streamline workflows and align everyone.",
    icon: Groups2OutlinedIcon,
  },
  {
    title: "Accelerate Time-to-Market",
    desc: "Deliver campaigns faster with ready-to-use assets.",
    icon: RocketLaunchOutlinedIcon,
  },
  {
    title: "Maximize Asset Value",
    desc: "Leverage every asset to its fullest potential.",
    icon: TrendingUpOutlinedIcon,
  },
];

export default function JourneySection() {
  return (
    <Box
      sx={{
        background: "#FFF",
        px: {
          xs: "16px",
          customBreakpoint: "84px",
          md: "48px",
        },
        py: {
          xs: "48px",
          customBreakpoint: "48px",
          md: "42px",
        },
      }}
    >
      <Box
        sx={{
          maxWidth: "1272px",
          mx: "auto",
          background: "#FAFAFA",
          borderRadius: "16px",
          padding: "16px",
          gap: "16px",

          // px: {
          //   xs: "20px",
          //   sm: "28px",
          //   md: "20px",
          //   lg: "24px",
          // },

          // py: {
          //   xs: "24px",
          //   sm: "32px",
          //   md: "36px",
          // },
        }}
      >
        {/* Desktop */}
        <Box
          sx={{
            display: {
              xs: "none",
              lg: "flex",
            },
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: "8px",
          }}
        >
          {/* LEFT CONTENT */}
          <Box
            sx={{
              width: "259px",
              flexShrink: 0,
              px: "8px",
              py: "16px",
            }}
          >
            <Typography
              sx={{
                fontSize: "1.1rem",
                fontWeight: 600,
                lineHeight: 1.6,
                letterSpacing: "0.15px",
                color: "#2A2177",
              }}
            >
              Why the Journey Matters
            </Typography>

            <Typography
              sx={{
                mt: "8px",
                fontSize: "0.875rem",
                fontWeight: 400,
                lineHeight: 1.4,
                letterSpacing: "0.17px",
                color: "#00000099",
              }}
            >
              Helping organizations unlock the full potential of their digital assets.
            </Typography>
          </Box>

          {/* RIGHT ITEMS */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "space-between",
              gap: "24px",
            }}
          >
            {items.map((item, index) => {
              const Icon = item.icon;
              return (
                <Box
                  key={index}
                  sx={{
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  {/* TOP */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "8px",
                      // px: "8px",
                      py: "16px",
                      // height: "122px",
                      // width: "245.25px",
                    }}
                  >
                    {/* ICON */}

                    <GradientIcon
                      icon={Icon}
                      size={24}
                      bordered
                      boxSize={40}
                      borderRadius={8}
                      borderWidth={2}
                      // angle="90"
                      // sx={{ margin: "0 auto 16px" }}
                      // sx={{ mb: "16px" }}
                    />
                    {/* <Box
                    sx={{
                      width: "52px",
                      height: "52px",
                      borderRadius: "12px",

                      border: "2px solid transparent",

                      background:
                        "linear-gradient(#fff,#fff) padding-box, linear-gradient(180deg,#FF6FB5 0%,#5533FF 100%) border-box",

                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",

                      flexShrink: 0,

                      "& svg": {
                        fontSize: "28px",
                        color: "#7B3EF0",
                      },
                    }}
                  >
                    {item.icon}
                  </Box> */}

                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 600,
                        lineHeight: 1.3,
                        letterSpacing: "0.15px",
                        color: "#000000DE",
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Box>

                  {/* DESCRIPTION */}
                  <Typography
                    sx={{
                      // mt: "16px",
                      fontSize: "0.875rem",
                      fontWeight: 400,
                      lineHeight: 1.43,
                      letterSpacing: "0.17px",
                      color: "#00000099",
                    }}
                  >
                    {item.desc}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>

        {/* TABLET */}
        <Box
          sx={{
            // width: "600px",
            // height: "350px",
            display: {
              xs: "none",
              customBreakpoint: "block",
              lg: "none",
            },
          }}
        >
          {/* TITLE */}
          <Box
            sx={{
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: "1.1rem",
                fontWeight: 600,
                lineHeight: 1.6,
                letterSpacing: "0.15px",
                color: "#2A2177",
              }}
            >
              Why the Journey Matters
            </Typography>

            <Typography
              sx={{
                mt: "8px",
                fontSize: "0.875rem",
                fontWeight: 400,
                lineHeight: 1.4,
                letterSpacing: "0.17px",
                color: "#00000099",
              }}
            >
              Helping organizations unlock the full potential of their digital assets.
            </Typography>
          </Box>

          {/* GRID */}
          <Box
            sx={{
              mt: "40px",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "40px 32px",
            }}
          >
            {items.map((item, index) => {
              const Icon = item.icon;
              return (
                <Box key={index}>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                      px: "16px",
                      py: "16px",
                    }}
                  >
                    <GradientIcon
                      icon={Icon}
                      size={24}
                      bordered
                      boxSize={40}
                      borderRadius={8}
                      borderWidth={2}
                      // angle="90"
                      // sx={{ margin: "0 auto 16px" }}
                      // sx={{ mb: "16px" }}
                    />
                    {/* <Box
                    sx={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "12px",
                      border: "2px solid transparent",

                      background:
                        "linear-gradient(#fff,#fff) padding-box, linear-gradient(180deg,#FF6FB5 0%,#5533FF 100%) border-box",

                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",

                      "& svg": {
                        fontSize: "24px",
                        color: "#7B3EF0",
                      },
                    }}
                  >
                    {item.icon}
                  </Box> */}

                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 600,
                        lineHeight: 1.3,
                        letterSpacing: "0.15px",
                        color: "#000000DE",
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Box>

                  <Typography
                    sx={{
                      // mt: "16px",
                      px: "16px",
                      fontSize: "0.875rem",
                      fontWeight: 400,
                      lineHeight: 1.43,
                      letterSpacing: "0.17px",
                      color: "#00000099",
                    }}
                  >
                    {item.desc}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>

        {/* MOBILE */}
        <Box
          sx={{
            display: {
              xs: "block",
              customBreakpoint: "none",
              md: "none",
            },
            padding: "16px",
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              fontSize: "1.1rem",
              fontWeight: 600,
              lineHeight: 1.6,
              letterSpacing: "0.15px",
              color: "#2A2177",
            }}
          >
            Why the Journey Matters
          </Typography>

          <Typography
            sx={{
              mt: "8px",
              textAlign: "center",
              fontSize: "0.875rem",
              fontWeight: 400,
              lineHeight: 1.4,
              letterSpacing: "0.17px",
              color: "#00000099",
            }}
          >
            Helping organizations unlock the full potential of their digital assets.
          </Typography>

          <Box
            sx={{
              mt: "32px",
              display: "flex",
              flexDirection: "column",
              gap: "4px",
            }}
          >
            {items.map((item, index) => {
              const Icon = item.icon;
              return (
                <Box
                  key={index}
                  sx={{
                    background: "#EFEFEF",
                    borderRadius: "16px",
                    p: "16px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    <GradientIcon
                      icon={Icon}
                      size={24}
                      bordered
                      boxSize={40}
                      borderRadius={8}
                      borderWidth={2}
                      // angle="90"
                      // sx={{ margin: "0 auto 16px" }}
                      // sx={{ mb: "16px" }}
                    />
                    {/* <Box
                    sx={{
                      width: "72px",
                      height: "72px",
                      borderRadius: "16px",
                      border: "3px solid transparent",

                      background:
                        "linear-gradient(#fff,#fff) padding-box, linear-gradient(180deg,#FF6FB5 0%,#5533FF 100%) border-box",

                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",

                      flexShrink: 0,

                      "& svg": {
                        fontSize: "36px",
                        color: "#7B3EF0",
                      },
                    }}
                  >
                    {item.icon}
                  </Box> */}

                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 600,
                        lineHeight: 1.3,
                        letterSpacing: "0.15px",
                        color: "#000000DE",
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Box>

                  <Typography
                    sx={{
                      // px: "8px",
                      py: "16px",
                      fontSize: "0.875rem",
                      fontWeight: 400,
                      lineHeight: 1.43,
                      letterSpacing: "0.17px",
                      color: "#00000099",
                    }}
                  >
                    {item.desc}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
